import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Store } from '@ngxs/store';
// State
import { GenericIntegrationState } from './state/generic-integation.state';
import { ClearSelectedIntegration } from './state/actions/generic-integation.actions';
// Service
import {
	BroadcastService,
	ObjectUtils
} from '@cv-invision/core';
// Model
import {
	BroadcastEventModel,
	LeftNavEventType
} from '@cv-invision/core';
import { IntegrationsUrlParamsModel } from './models/integrations-url-params.model';

@Component({
	selector: 'cv-invision-ux-generic-integrations',
	template: `<router-outlet></router-outlet>`
})
export class GenericIntegrationsComponent implements OnInit, OnDestroy {

	integrationMenu$: Observable<Array<any>> = this.store.select(GenericIntegrationState.getIntegrationMenu);

	private atComponentDestroy: Subject<any> = new Subject<any>();

	constructor(
		private router: Router,
		private store: Store,
		private broadcastService: BroadcastService
	) { }

	ngOnInit(): void {
		this.registerListeners();
	}

	/**
	 * Register all State Listeners
	 */
	registerListeners(): void {
		this.integrationMenu$.pipe(takeUntil(this.atComponentDestroy)).subscribe(menu => {
			if (menu?.length) {
				// Update Left Menu
				this.broadcastService.broadcast({
					name: LeftNavEventType.RENDER,
					event: {
						items: ObjectUtils.recursiveDeepCopy(menu)
					}
				});
			}
		});

		this.broadcastService
			.onEvent('GC_SUBHEADER_BACK')
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(() => {
				const url = this.store.selectSnapshot(GenericIntegrationState.getIntegrationBackUrl);
				this.router.navigate([url]);
			});
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next(true);
		this.atComponentDestroy.complete();

		this.store.dispatch(new ClearSelectedIntegration());
	}

}
